import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../../auth/useAuth';
import Swal from 'sweetalert2';
import { getError, isUndNullEmpNew, navSetting, sendMessageCloseCurrentWindow, settings, styles, getLanguageObj, getResponse, checkFileOnLine } from '../../helpers/UtilsHelper';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { RoleSessionClass } from '../../classes/role/roleSessionClass';

const { app, colors, html, icons, images, labels, messages, } = settings;
const { urls } = app?.backend;

// const languageObj = { id: 'en', };
const currentMethod = 'functionrender';

export default function Menu({
    viewName = '',
    process = '',
    processLevel1 = '',
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const [account, setAccount] = useState({ photoURL: '', });
    const isMount = useRef(true);
    const viewNameLocal = !isUndNullEmpNew({ data: viewName, subMethod: currentMethod })?.result ? viewName : '';
    const processLocal = !isUndNullEmpNew({ data: process, subMethod: currentMethod })?.result ? process : '';
    const userRoleSession = RoleSessionClass?.getClass(auth?.account?.role);
    //#endregion variables

    //#region methods
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            // if (isUndNullEmpNew({ data: auth?.account?.photoURL, subMethod: currentMethod })?.result ||
            //     auth?.account?.photoURL?.includes(images?.noImage)) {
            //     setAccount(prev => ({ ...prev, photoURL: auth?.isLoged() ? `${app?.url}${images?.noImage}` : '' }));
            //     return;
            // }

            response = await checkFileOnLine({
                url: auth?.account?.photoURL,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess) return;
            if (response?.isSuccess && !response?.isWarning) setAccount(prev => ({ ...prev, photoURL: auth?.account?.photoURL }));
            if (response?.isWarning) {
                setAccount(prev => ({ ...prev, photoURL: auth?.isLoged() ? `${app?.url}${images?.noImage}` : '' }))
                // auth.account.photoURL = `${app?.url}${images?.noImage}`;
                response.msgText = ''
            };
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, [auth?.account?.photoURL]);  // eslint-disable-line react-hooks/exhaustive-deps

    const signOutShowModel = async (e) => {
        const currentMethod = 'signOutShowModel';
        let response = getResponse({ type: 0 });
        let savePath = false;
        try {
            e?.preventDefault();
            const swalProperties = {
                icon: 'warning',
                title: labels?.warning?.[languageObj?.id],
                html: messages?.areYouSureToLogOut?.[languageObj?.id],
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                }
            };

            const { isConfirmed, } = await Swal.fire({ ...swalProperties });
            if (!isConfirmed) return;

            response = auth?.logout({
                subMethod: `Menu - ${currentMethod}`,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            // localStorage.removeItem(settings?.localStorage?.redirectId);
            response.urlGoTo = urls?.login;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: 'Menu - function', subMethod_: currentMethod });
        } finally {
            // CSN (Condition Standard Notification)
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                savePath: savePath,
                languageId: languageObj?.id,
            });
        }
    }
    //#endregion methods

    return (
        <aside className='main-sidebar sidebar-dark-primary elevation-2 border-right-0 sidebar-dark-custom'>

            {/* Brand Logo */}
            <a href={urls?.home} className='brand-link border-bottom-0 d-flex align-items-center justify-content-center brand-link-subtle'>
                <img src={images?.appLogo} alt='appLogo' className='brand-image img-circle elevation-2 brand-image-custom' />
                <span className='brand-text font-weight-bold text-white brand-text-spaced'>{app?.name}</span>
            </a>

            {/* Sidebar */}
            <div className='sidebar px-2'>

                {/* Sidebar user panel (optional) */}
                {auth?.isLoged() ? (
                    <div className='user-panel mt-3 pb-3 mb-3 d-flex align-items-center sidebar-user-panel'>
                        <div className='image'>
                            <a href={urls?.profile}>
                                <img style={{ ...styles.leftMenuUserPicture }} src={auth?.account !== null && !isUndNullEmpNew({ data: account?.photoURL, subMethod: currentMethod })?.result ? account?.photoURL : images?.noImage} className='img-circle elevation-2 sidebar-user-avatar' alt='UserImage' />
                            </a>
                        </div>
                        <div className='info ml-2'>
                            <a href={urls?.profile} className='d-block text-white font-weight-bold sidebar-username'>
                                {auth?.account !== null && !isUndNullEmpNew({ data: auth?.account?.displayName, subMethod: currentMethod, })?.result ? auth?.account?.displayName : settings?.undefined}
                            </a>
                        </div>
                    </div>
                ) : (
                    <></>
                )}

                {/* SidebarSearch Form */}
                <div className='form-inline mt-2 mb-3'>
                    <div className='input-group w-100' data-widget='sidebar-search'>
                        <input className='form-control form-control-sidebar border-0 sidebar-search-input'
                            type='search'
                            placeholder='Search...'
                            aria-label='Search' />
                        <div className='input-group-append'>
                            <button className='btn btn-sidebar border-0 sidebar-search-btn'>
                                <i className={icons?.fasFa?.search} />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Sidebar Menu */}
                <nav className='mt-2'>

                    {/* <ul className='nav nav-pills nav-sidebar flex-column' data-widget='treeview' role='menu' data-accordion='true'> */}
                    <ul className='nav nav-pills nav-sidebar flex-column nav-compact nav-child-indent' data-widget='treeview' role='menu' data-accordion='false'>
                        {/* Add icons to the links using the .nav-icon class with font-awesome or any other icon font library */}

                        {/* Home */}
                        <li className={viewNameLocal === 'home' && !isUndNullEmpNew({ data: processLocal, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                            <a href='#nothing' className={(viewNameLocal === 'home' && !isUndNullEmpNew({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                <i className={`nav-icon ${icons?.fasFa?.home} ${viewNameLocal === 'home' ? 'text-white' : 'text-muted'}`} />
                                <p className='font-weight-normal'>{labels?.home?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} />
                                </p>
                            </a>
                            <ul className='nav nav-treeview'>
                                <li className={navSetting?.navItem}>
                                    <a href={urls?.home} className={(processLocal === 'home' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                        <i className={icons?.farFa?.circleNavIcon} />
                                        <p >{labels?.home?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                                <li className={navSetting?.navItem}>
                                    <a href={urls?.about} className={(processLocal === 'about' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                        <i className={icons?.farFa?.circleNavIcon} />
                                        <p >{labels?.about?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                                <li className={navSetting?.navItem}>
                                    <a href={urls?.contact} className={(processLocal === 'contact' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                        <i className={icons?.farFa?.circleNavIcon} />
                                        <p >{labels?.contact?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                                <li className={navSetting?.navItem}>
                                    <a href={urls?.privacy} className={(processLocal === 'privacy' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                        <i className={icons?.farFa?.circleNavIcon} />
                                        <p >{labels?.privacy?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                            </ul>

                        </li>

                        {/* Accounts (users) */}
                        {(!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod })?.result && !userRoleSession?.isAnonymous) ? (
                            <li className={viewNameLocal === 'accounts' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                                <a href='#nothing' className={(viewNameLocal === 'accounts' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                    <i className={`nav-icon ${icons?.fasFa?.users} ${viewNameLocal === 'accounts' ? 'text-white' : 'text-muted'}`} />
                                    <p className='font-weight-normal'>{labels?.accounts?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.accounts} className={(process === 'accounts' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.accounts?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        ) : (
                            <div></div>
                        )}

                        {/* Items */}
                        {(!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod })?.result &&
                            !userRoleSession?.isAnonymous &&
                            userRoleSession?.getIsAdminOrMaster()) ? (
                            <li className={viewNameLocal === 'items' && !isUndNullEmpNew({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                                <a href='#nothing' className={(viewNameLocal === 'items' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, }) ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                    <i className={`nav-icon ${icons?.fasFa?.tasks} ${viewNameLocal === 'items' ? 'text-white' : 'text-muted'}`} />
                                    <p className='font-weight-normal'>{labels?.items?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.process} className={(process === 'process' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.process?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        ) : (
                            <div></div>
                        )}

                        {/* Sales */}
                        {(!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod, })?.result &&
                            !userRoleSession?.isAnonymous &&
                            userRoleSession?.getIsAdminOrMaster()) ? (
                            <li className={viewNameLocal === 'sales' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                                <a href='#nothing' className={(viewNameLocal === 'sales' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                    <i className={`nav-icon ${icons?.fasFa?.store} ${viewNameLocal === 'sales' ? 'text-white' : 'text-muted'}`} />
                                    <p className='font-weight-normal'>{labels?.sales?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.sales} className={(process === 'sales' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.sales?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        ) : (
                            <div></div>
                        )}

                        {/* Rates */}
                        {(!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod, })?.result &&
                            !userRoleSession?.isAnonymous &&
                            userRoleSession?.getIsAdminOrMaster()) ? (
                            <li className={viewNameLocal === 'rates' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                                <a href='#nothing' className={(viewNameLocal === 'rates' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                    <i className={`nav-icon ${icons?.fasFa?.chartBar} ${viewNameLocal === 'rates' ? 'text-white' : 'text-muted'}`} />
                                    <p className='font-weight-normal'>{labels?.rates?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.rates} className={(process === 'rates' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.rates?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        ) : (
                            <div></div>
                        )}

                        {/* Bots */}
                        {(!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod, })?.result &&
                            !userRoleSession?.isAnonymous) ? (
                            <li className={viewNameLocal === 'bots' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                                <a href='#nothing' className={(viewNameLocal === 'bots' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                    <i className={`nav-icon ${icons?.fasFa?.robot} ${viewNameLocal === 'bots' ? 'text-white' : 'text-muted'}`} />
                                    <p className='font-weight-normal'>{labels?.bots?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    {userRoleSession?.getIsAdminOrMaster() ? <li className={navSetting?.navItem}>
                                        <a href={urls?.bots} className={(process === 'bots' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.index?.[languageObj?.id]}</p>
                                        </a>
                                    </li> : <></>}
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.ai} className={(process === 'ai' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.artificialIntelligence?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.advancedCommands} className={(process === 'advancedCommands' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.advancedCommands?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.userLlmModelSelects} className={(process === urls?.userLlmModelSelects?.replaceAll('/', '') ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.models?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        ) : (
                            <div></div>
                        )}

                        {/* Settings (admin or master) */}
                        {(!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod })?.result &&
                            userRoleSession?.getIsAdminOrMaster()) ? (
                            <li className={viewNameLocal === 'settings' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                                <a href='#nothing' className={(viewNameLocal === 'settings' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navLinkActive : navSetting?.navLink) + ' mb-1 sidebar-nav-link-rounded'}>
                                    <i className={`nav-icon ${icons?.fasFa?.cogs} ${viewNameLocal === 'settings' ? 'text-white' : 'text-muted'}`} />
                                    <p className='font-weight-normal'>{labels?.settings?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    {!isUndNullEmpNew({ data: auth?.account, subMethod: currentMethod, })?.result &&
                                        userRoleSession?.isMaster ?
                                        <li className={navSetting?.navItem}>
                                            <a href={urls?.roles} className={(process === 'roles' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                                <i className={icons?.farFa?.circleNavIcon} />
                                                <p >{labels?.roles?.[languageObj?.id]}</p>
                                            </a>
                                        </li> : null}

                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.users} className={(process === 'users' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.users?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.notifications} className={(process === 'notifications' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.notifications?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className={navSetting?.navItem}>
                                        <a href={urls?.notificationToasts} className={(process === 'notificationsToats' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.notificationsToast?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    {/*  Settings / metrics */}
                                    <li className={viewNameLocal === 'settings' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result && process === 'metrics' ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                        <a href={urls?.notificationToasts} className={(navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={viewNameLocal === 'settings' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result && process === 'metrics' && !isUndNullEmpNew({ data: processLevel1, subMethod: currentMethod, })?.result ?
                                                icons?.fasFa?.circleDotNavIcon : icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.metrics?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                        </a>
                                        <ul className='nav nav-treeview'>
                                            <li className={navSetting?.navItem}>
                                                <a href={urls?.mlSites} className={(process === 'metrics' && processLevel1 === 'sites' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-3 mb-1 sidebar-nav-sublink-rounded'}>
                                                    <i className={icons?.farFa?.circleNavIcon} />
                                                    <p >{labels?.sites?.[languageObj?.id]}</p>
                                                </a>
                                            </li>
                                            <li className={navSetting?.navItem}>
                                                <a href={urls?.mlCategories} className={(process === 'metrics' && processLevel1 === 'categories' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-3 mb-1 sidebar-nav-sublink-rounded'}>
                                                    <i className={icons?.farFa?.circleNavIcon} />
                                                    <p >{labels?.categories?.[languageObj?.id]}</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    {/*  Settings / largeLanguageModel */}
                                    <li className={viewNameLocal === 'settings' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result && process === 'largeLanguageModels' ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                        <a href={urls?.largeLanguageModels} className={(navSetting?.navLink) + ' mx-2 mb-1 sidebar-nav-sublink-rounded'}>
                                            <i className={viewNameLocal === 'settings' && !isUndNullEmpNew({ data: process, subMethod: currentMethod, })?.result && process === 'largeLanguageModels' && !isUndNullEmpNew({ data: processLevel1, subMethod: currentMethod, })?.result ?
                                                icons?.fasFa?.circleDotNavIcon : icons?.farFa?.circleNavIcon} />
                                            <p >{labels?.largeLanguageModel?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                        </a>
                                        <ul className='nav nav-treeview'>
                                            <li className={navSetting?.navItem}>
                                                <a href={urls?.largeLanguageModels} className={(process === 'largeLanguageModels' && processLevel1 === 'list' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-3 mb-1 sidebar-nav-sublink-rounded'}>
                                                    <i className={icons?.farFa?.circleNavIcon} />
                                                    <p >{labels?.largeLanguageModels?.[languageObj?.id]}</p>
                                                </a>
                                            </li>
                                            <li className={navSetting?.navItem}>
                                                <a href={urls?.llmModels} className={(process === 'largeLanguageModels' && processLevel1 === 'llmModels' ? navSetting?.navLinkActive : navSetting?.navLink) + ' mx-3 mb-1 sidebar-nav-sublink-rounded'}>
                                                    <i className={icons?.farFa?.circleNavIcon} />
                                                    <p >{labels?.models?.[languageObj?.id]}</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>

                            </li>
                        ) : (
                            <div></div>
                        )}

                        <li className='nav-header text-warning'>
                            <hr className='sidebar-separator' />
                            {labels?.session?.[languageObj?.id].toUpperCase()}
                        </li>

                        <li className={navSetting?.navItem}>
                            {
                                auth?.isLoged() ?
                                    <Link to={auth?.isLoged() ? '/logOff' : urls?.login}
                                        onClick={auth?.isLoged() ? (e) => signOutShowModel(e) : null}
                                        className={(navSetting?.navLink) + ' mt-3 sidebar-btn-logout'}>
                                        <i className={`${auth?.isLoged() ? icons?.fasFa?.signOut : icons?.fasFa?.signIn} nav-icon`} />
                                        <p className='font-weight-bold'>{auth?.isLoged() ? labels?.logOff : labels?.login?.[languageObj?.id]}</p>
                                    </Link> :
                                    <a className={navSetting?.navLink + ' mt-3 sidebar-btn-login'}
                                        href={urls?.login}>
                                        <i className={`${icons?.fasFa?.signIn} nav-icon`} />
                                        <p className='font-weight-bold'>{labels?.login?.[languageObj?.id]}</p>
                                    </a>
                            }
                        </li>
                    </ul>

                </nav>
                {/* /.sidebar-menu */}

            </div > {/* /.sidebar */}
        </aside >
    );
}